import React, { useEffect } from "react";
import "../App.css";
import { DataTable } from "genesys-react-components";

export function DataTableRows({ dataTable, collapse }) {
  useEffect(() => {
    console.log(
      "DataTableRows component mounted with dataTable:",
      dataTable.schema
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const sortedProperties = Object.entries(dataTable.schema.properties).sort(
    ([, a], [, b]) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
  );

  const tableProps = {
    className: "datatable-rows-table",
    headerRow: {
      cells: sortedProperties.map(([key, value]) => ({
        renderedContent: <>{value.title || key}</>,
        content: value.title || key,
        align: "left",
      })),
      // [
      //   {
      //     content: "Users",
      //     align: "center",
      //   },
      //   {
      //     content: "Division",
      //     align: "center",
      //   },
      //   {
      //     content: "Roles",
      //     align: "center",
      //   },
      //   {
      //     content: "Last Login",
      //     align: "center",
      //   },
      //   {
      //     content: "Station",
      //     align: "center",
      //   },
      //   {
      //     content: "Auto Answer?",
      //     align: "center",
      //   },
      //   {
      //     content: "Team",
      //     align: "center",
      //   },
      //   {
      //     content: "User ID",
      //     align: "center",
      //   },
      // ],
    },
    indentation: 0,
    rows:
      // [
      //   {
      //     cells: [
      //       {
      //         content: "Users",
      //         align: "center",
      //       },
      //       {
      //         content: "Division",
      //         align: "center",
      //       },
      //       {
      //         content: "Roles",
      //         align: "center",
      //       },
      //       {
      //         content: "Last Login",
      //         align: "center",
      //       },
      //       {
      //         content: "Station",
      //         align: "center",
      //       },
      //       {
      //         content: "Auto Answer?",
      //         align: "center",
      //       },
      //       {
      //         content: "Team",
      //         align: "center",
      //       },
      //       {
      //         content: "User ID",
      //         align: "center",
      //       },
      //     ],
      //   },
      // ],
      dataTable.rows &&
      dataTable.rows.map((row, index) => {
        return {
          cells: sortedProperties.map(([key, value]) => ({
            renderedContent: <>{`${row[key]}`}</>,
            content: `${row[key]}`,
            align: "left",
          })),
        };
      }),
  };

  return (
    <>
      {dataTable.rows && (
        <DataTable
          sortable={true}
          filterable={true}
          headerRow={tableProps.headerRow}
          rows={tableProps.rows}
          className="datatable-rows-table"
        />
      )}
    </>
  );
}
